import React from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

import { auth } from "../App";

function LogoutButton() {
  const signOut = () => {
    auth
      .signOut()
      .then(function () {
        // Sign-out successful.
          localStorage.setItem("user", null);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <Link
      style={{ color: "white", textDecoration: "none" }}
      to="/"
    >
      <Button
        // type="submit"
        // variant="contained"
        // color="secondary"
        onClick={signOut}
      >
        <h2 style={{ color: "white", textDecoration: "none" }}>
          Sign out
          </h2>
      </Button>
    </Link>
  );
}

export default LogoutButton;
